import { useEffect, useState, useRef } from 'react';
import { useStore } from '../../store/useStore';

export const CooldownIndicator = () => {
    const lastAttackTime = useStore((state) => state.lastAttackTime);
    const [progress, setProgress] = useState(1); // 0 to 1
    const frameRef = useRef(0);

    const COOLDOWN_MS = 500;

    useEffect(() => {
        const update = () => {
            const now = Date.now();
            const elapsed = now - lastAttackTime;

            if (elapsed < COOLDOWN_MS) {
                const p = elapsed / COOLDOWN_MS;
                setProgress(p);
                frameRef.current = requestAnimationFrame(update);
            } else {
                setProgress(1); // Ready
            }
        };

        if (Date.now() - lastAttackTime < COOLDOWN_MS) {
            update();
        } else {
            setProgress(1);
        }

        return () => cancelAnimationFrame(frameRef.current);
    }, [lastAttackTime]);

    // Render around crosshair (center screen)
    // Assuming crosshair is handled by CSS or pointer lock, we just render a circle.

    if (progress >= 1) return null; // Hide when ready

    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            zIndex: 1001, // Above crosshair usually?
            width: '40px',
            height: '40px'
        }}>
            <svg width="40" height="40" viewBox="0 0 40 40" style={{ transform: 'rotate(-90deg)' }}>
                {/* Background Circle */}
                <circle
                    cx="20"
                    cy="20"
                    r="18"
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.2)"
                    strokeWidth="4"
                />
                {/* Progress Circle */}
                <circle
                    cx="20"
                    cy="20"
                    r="18"
                    fill="none"
                    stroke="#00ffff"
                    strokeWidth="4"
                    strokeDasharray={`${2 * Math.PI * 18}`}
                    strokeDashoffset={`${2 * Math.PI * 18 * (1 - progress)}`}
                    style={{ transition: 'stroke-dashoffset 0.05s linear' }}
                />
            </svg>
        </div>
    );
};
